export interface StatusInfo {
  statusCode: number,
  statusDate: string
}

export interface StatusItem {
  id: number,
  label: string,
  icon: string | null,
  step: number,
  tag: string
}

export interface Status extends StatusItem {
  date: Date
}

export const STATUS_CODE: StatusItem[] = [
  {
    id: 2,
    label: 'Equipement pris en charge',
    icon: null,
    step: 1,
    tag: 'En cours'
  },
  {
    id: 3,
    label: 'En cours d\'acheminement vers la plateforme logistique',
    icon: null,
    step: 1,
    tag: 'En cours'
  },
  {
    id: 4,
    label: 'Réception par le centre de réparation',
    icon: null,
    step: 2,
    tag: 'En cours'
  },
  {
    id: 5,
    label: 'En cours de traitement par le centre de réparation',
    icon: null,
    step: 2,
    tag: 'En cours'
  },
  {
    id: 6,
    label: 'Emission d\'un devis (hors garantie).',
    icon: 'tri-gdt',
    step: 2,
    tag: 'En cours'
  },
  {
    id: 8,
    label: 'En cours de traitement par le centre de réparation',
    icon: null,
    step: 2,
    tag: 'En cours'
  },
  {
    id: 10,
    label: 'Votre mobile est disponible dans votre boutique Bouygues Telecom.',
    icon: null,
    step: 3,
    tag: 'En cours'
  },
  {
    id: 12,
    label: 'En cours d\'acheminement vers le centre de réparation',
    icon: null,
    step: 1,
    tag: 'En cours'
  },
  {
    id: 33,
    label: 'Réception par le centre logistique',
    icon: null,
    step: 1,
    tag: 'En cours'
  },
  {
    id: 71,
    label: 'Vous avez validé le devis.',
    icon: 'tri-check-circle',
    step: 2,
    tag: 'En cours'
  },
  {
    id: 72,
    label: 'Vous avez refusé le devis.',
    icon: 'tri-times-circle',
    step: 2,
    tag: 'En cours'
  },
  {
    id: 73,
    label: 'Le délais de réponse pour votre devis a expiré. <br />Votre mobile vous sera réexpédié en,l\'état.',
    icon: null,
    step: 2,
    tag: 'En cours'
  },
  {
    id: 91,
    label: 'En cours d\'acheminement dans votre boutique Bouygues Telecom.',
    icon: null,
    step: 3,
    tag: 'En cours'
  },
  {
    id: 92,
    label: 'En cours d\'acheminement à votre domicile.',
    icon: null,
    step: 3,
    tag: 'En cours'
  },
  {
    id: 111,
    label: 'La restitution de votre mobile a été faite en boutique Bouygues Telecom.',
    icon: null,
    step: 3,
    tag: 'Terminé'
  },
  {
    id: 112,
    label: 'La livraison a été effectuée à votre domicile.',
    icon: null,
    step: 3,
    tag: 'Terminé'
  },
];